import React from 'react'
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

import { CustomTooltip } from '@application/Interfaces/Features/Graph/CustomTooltip'
import { useOrganization } from '@src/Application/Interfaces/Hooks/useOrganization/useOrganization'
import { GraphBarType, ThemeModeType } from '@src/Application/Types/ComponentTypes'

import { mapData } from './utils'

const Layout: Record<ThemeModeType, Record<string, string>> = {
    Light: {
        barColor: 'p500',
        axisColor: 'g500',
        gridColor: 'g200',
    },
    Dark: {
        barColor: 'a600',
        axisColor: 'white',
        gridColor: 'p500',
    },
}

export const BarGraph = (props: GraphBarType): JSX.Element => {
    const { barData, mode, legendDescriptions } = props

    const { theme } = useOrganization()

    const gridColorCode = Layout[mode].gridColor
    const gridColor = theme.color[gridColorCode]

    const axisColorCode = Layout[mode].axisColor
    const axisColor = theme.color[axisColorCode]

    const barColorCode = Layout[mode].barColor
    const barColor = theme.color[barColorCode]

    const bars = barData[0].values.split(';')
    const legendLabels = legendDescriptions?.split(';')

    return (
        <ResponsiveContainer width="100%" height={300}>
            <BarChart data={mapData(barData)}>
                <CartesianGrid stroke={gridColor} />
                <XAxis dataKey="name" tick={{ fill: axisColor }} height={40} />
                <Legend />
                <YAxis tick={{ fill: axisColor }} />
                <Tooltip
                    content={<CustomTooltip />}
                    wrapperStyle={{ outline: 'none' }}
                    cursor={{ fill: 'transparent' }}
                />
                {bars.map((_, i) => (
                    <Bar key={`bar${i}`} dataKey={`bar${i}`} fill={barColor} name={legendLabels?.[i]} />
                ))}
            </BarChart>
        </ResponsiveContainer>
    )
}
